/* eslint-disable no-unused-vars */
import { Injectable } from '@angular/core';
import { Action, NgxsOnInit, Selector, State, StateContext } from '@ngxs/store';

import { ClearClm, LoadClm } from './clm.action';
import { UserInfoService } from '../services/user-info.service';
import { UserResponse } from '../interfaces/base-core-services.interface';
import { CommonRdmService } from 'src/app/layout/services/common-rdm.service';
import { ClmUsers } from './clm';
import { DefaultCompanyService } from '../../layout/services/default-company.service';
@State<ClmUsers>({
  name: 'clm',
  defaults: {
    content: [],
  },
})
@Injectable()
export class ClmState implements NgxsOnInit {
  clmMap = new Map();
  userInfo:any =[]
  isCalled=false


  constructor(
    private userInfoService: UserInfoService,
    private commonRdmService: CommonRdmService,
    private defaultCompanyService: DefaultCompanyService
  ) {}

  ngxsOnInit(ctx: StateContext<any>) {
    // ctx.dispatch(new LoadClm());
    this.userInfoService.getUserInfo$().subscribe((data:any) => {
      if (data && data.companyDetails){
        this.userInfo = data;
        if(!this.isCalled){
          this.isCalled =true;
          ctx.dispatch(new LoadClm());
        }
      }
    });
  }

  @Selector()
  static getClmList(state: any) {
    return state.content;
  }

  @Action(LoadClm)
  GetClm(context: StateContext<any>) {
    const state = context.getState();
    if (this.userInfo && this.userInfo.companyDetails) {
      this.getFilteredBrokers(this.userInfo, state, context);
    }
  }

  @Action(ClearClm)
  clearClmData(context: StateContext<any>) {
    this.clmMap = new Map();
    context.setState({
      content:[],
    });
  }

  getFilteredBrokers(userInfo: UserResponse, state: any, context: any) {
    this.clmMap = new Map();
    const userInfoLicenseActivityGroup = userInfo.licenseActivityGroup
      ? userInfo.licenseActivityGroup
      : null;
    const traderBody = { licenseGroup: 'Traders', paged: false };
    const warehouseBody = { licenseGroup: 'Customs Warehouse', paged: false };
    const brokerInfo = { paged: false };
    if (userInfoLicenseActivityGroup) {
      // Getting Trader -> Always
      this.commonRdmService.setUserTypeBOLAG('Trader');
      const data = this.getTraders(traderBody);
      this.clmMap.set('Traders', data);
      this.commonRdmService.setUserTypeBOLAG('Customs Warehouse');
      const warehouseData = this.getTraders(warehouseBody);
      this.clmMap.set('CustomsWarehouse', warehouseData);
      this.commonRdmService.setUserTypeBOLAG('Broker');
      const brokerData: any[] =[];
      this.defaultCompanyService
      .getClmAuthBroker(userInfo.customerId, brokerInfo)
      .subscribe((res: any) => {
        if(res.content?.length>0){
          res?.content?.forEach((broker:any) =>{
            brokerData.push({
              id: broker.brokerCode,
              name: broker.brokerName,
            });
          })
          this.clmMap.set('BrokersFiltered', brokerData);
          context.setState({
            ...state,
            content: this.strMapToObj(this.clmMap),
          });
        }else{
          context.setState({
            ...state,
            content: this.strMapToObj(this.clmMap),
          });
        }
      });

    }
  }

  getTraders(traderBody: any) {
    const traderData: any[] = [];
    this.defaultCompanyService
      .getClmTraders(traderBody)
      .subscribe((res: any) => {
        if (res.content?.length > 0) {
          res?.content?.forEach((item: any) => {
            traderData.push({
              id: item.accountNo,
              name: item.clientName,
            });
          });
        }
      });
    return traderData;
  }

  strMapToObj(strMap: any) {
    const obj = Object.create(null);
    strMap.forEach((key: any, values: any) => {
      obj[values] = key;
    });
    return obj;
  }
}
